import React, {
  useState,
  useEffect,
} from 'react';
import {
  useWeb3React,
} from '@web3-react/core';
import styled from 'styled-components';
import {
  Box,
  Flex,
} from 'reflexbox';

import {
  Button,
  Modal,
  Text,
} from '../../style/components';

import {
  network,
  injected,
  walletConnect,
} from '../../store/connectors';

import MetaMaskIcon from '../../assets/img/metamask.png';
import WalletConnectIcon from '../../assets/img/walletConnectIcon.svg';

const ConnectorIcon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

function Web3Connector() {
  const {
    account,
    chainId,
    activate,
    active,
  } = useWeb3React();

  const [isWalletSelectionModalOpen, toggleWalletSelectionModal] = useState<boolean>(false);

  useEffect(() => {
    if (active === false) {
      activate(network);
    }
  }, [active, activate]);

  return (
    <>
      <Modal
        title="Connect to a wallet"
        isOpen={isWalletSelectionModalOpen}
        toggle={() => toggleWalletSelectionModal(!isWalletSelectionModalOpen)}
      >
        <Box width={1} py={1}>
          <Button
            genre="secondary"
            block
            onClick={async () => {
              try {
                activate(injected);
                toggleWalletSelectionModal(!isWalletSelectionModalOpen);
              } catch (e) {
                console.log(e);
              }
            }}
          >
            <Flex
              alignItems="center"
              justifyContent="center"
            >
              <ConnectorIcon src={MetaMaskIcon} alt="MetaMask icon" />
              MetaMask
            </Flex>
          </Button>
        </Box>

        <Box width={1} py={1}>
          <Button
            genre="secondary"
            block
            onClick={async () => {
              try {
                await activate(walletConnect);
                toggleWalletSelectionModal(!isWalletSelectionModalOpen);
              } catch (e) {
                console.log(e);
              }
            }}
          >
            <Flex
              alignItems="center"
              justifyContent="center"
            >
              <ConnectorIcon src={WalletConnectIcon} alt="WalletConnect icon" />
              WalletConnect
            </Flex>
          </Button>
        </Box>
      </Modal>
      <Modal
        title="Wrong network!"
        isOpen={chainId !== 1}
        toggle={() => {}}
      >
        <Box
          textAlign="center"
        >
          <Text>
            Please change your network to Mainnet.
          </Text>
        </Box>
      </Modal>
      <Button
        genre="secondary"
        onClick={() => toggleWalletSelectionModal(!isWalletSelectionModalOpen)}
      >
        {account ? (
          <>
            {`${account.substring(0, 5)}...${account.substring(account.length - 6, account.length)}`}
          </>
        ) : (
          'Connect to a wallet'
        )}
      </Button>
    </>
  );
}

export default Web3Connector;
